import React, { useState } from 'react';
import { Button, Container, createStyles, Grid, makeStyles, TextField, Theme, Typography } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { useHistory } from "react-router-dom";
import { ICliente } from '../../entities/catalogos/ICliente';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { ArrowRightAlt, Search } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { format } from "date-fns";
import LoadingDialog from '../controls/LoadingDialog';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import { setRecoleccionDestino, setRecoleccionOrigen } from '../../redux/actions/recoleccionActions';
import { initialSolicitud } from "../../redux/reducers/solicitudReducer";
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import { initialRecoleccionState } from '../../redux/reducers/recoleccionReducer';
import { initialMercancia } from '../../redux/reducers/mercanciaReducer';
import { Recoleccion } from '../../entities/catalogos/Recoleccion';
import { enums } from "../../enums/enums";
import { setUsuario } from '../../redux/actions/usuarioActions';
import swal from 'sweetalert2';
import { useSnackbar } from 'notistack';
import Help, { IHelp } from '../help/Help';
import ReferenciaNumberField from '../controls/ReferenciaNumberField';
import { currencyFormat, obtenerMercancias, completarValoresRecoleccion } from "../../blocks/utility";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { updateServicios } from "../../redux/actions/servicioAdicionalActions";
import { AreaServicio } from "../../entities/catalogos/AreaServicio";
import useGetInformacionOrigenDestino from "../../hooks/useGetInformacionOrigenDestino";
import { saveTiposEnvio } from "../../redux/actions/tipoEnvioActions";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import  DatePicker  from 'rsuite/DatePicker';
import CustomProvider from "rsuite/CustomProvider";
import es_ES from 'rsuite/locales/es_ES';
import en_US from 'rsuite/locales/en_US';
import moment from 'moment';
import "./datepickerStyle.css";
import { CotizacionHistorialDto } from '../../entities/cotizaciones/ICotizacionHistorialDto';
import { IResultApi } from '../../interfaces/IResultApi';
import { saveCliente } from '../../redux/actions/clienteActions';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        container: {
            width: "100%"
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0 0 20px 0",
            width: "100%"
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",

        },
        tr: {
            fontWeight: 600,
            textAlign: "center"
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            paddingTop: "10px"
        },
        label: {
            fontSize: '12px',
            fontWeight: 600,
            marginTop: "10px"
        },
        textField: {
            marginRight: theme.spacing(1),
            width: 180,
            backgroundColor: "#fff"
        },
        datePicker: {
            marginRight: theme.spacing(1),
            width: 180,
            height: 40,
            color: "#000",
            
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",

        },
        marginButton: {
            margin: "10px 0px 0 30px"
        },
        cellContent: {
            minWidth: "150px"
        },
        sectionTitle: {
            width: "100%",
            textAlign: "center",
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: "200px"
        }
    })
);

interface StateProps {
    cliente: ICliente
    usuario: IUsuario
    solicitud: Solicitud
    solicitudCopia: Solicitud
    ayuda: IHelp,
    serviciosAdicionales: ServicioAdicional[]
}

interface DispatchProps {
    saveCliente: typeof saveCliente
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setUsuario: typeof setUsuario
    updateServicios: typeof updateServicios
    saveTiposEnvio: typeof saveTiposEnvio
}

interface IFiltro {
    usuarioId: number,
    clienteId: number,
    cotizacionId?: number,
    fechaInicio: Date,
    fechaFin: Date
}

interface IResultAuthApi extends IResultApi {
    response: { token: string, refreshToken: string }
}

interface IDatosLogin {
    resultAuthApi: IResultAuthApi
    cliente: ICliente
    usuario: IUsuario
    tipoUsuario: string
    cotizacion: CotizacionHistorialDto
    cotizacionId: number,
    etiquetas: any,
    idioma: string,
    diasRAD: string,
    tieneConveniosHD: boolean
}

type Props = StateProps & DispatchProps & IDatosLogin;

const CotizacionLista = (props: Props) => {
    const classes = useStyles();
    const ocultarPortal = localStorage.getItem("ocultarPortal") === "true" || localStorage.getItem("ocultarPortal") === "1";
    const history = useHistory();
    const [cotizaciones, setCotizaciones] = useState<any[]>([]);
    const [showLoading, setLoading] = useState(false);
    const apiSource = useCommonApi();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const defaultStartDate = new Date();
    defaultStartDate.setDate(1);
    const defaultEndDate = new Date();
    const { enqueueSnackbar } = useSnackbar();
    //const [servicios, setServicios] = useState<ServicioAdicional[]>([]);
    const { getTipoServicio, saveServicioAdicionales } = useGetInformacionOrigenDestino(props.cliente,
        props.updateServicios, props.saveTiposEnvio);
    const [filtro, setFiltro] = useState<IFiltro>({
        usuarioId: props.usuario.id,
        clienteId: props.cliente.id,
        fechaInicio: defaultStartDate,
        fechaFin: defaultEndDate
    });
    const handleClick = () => {
        setLoading(true);
        actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {

            let documentoId = 0;
            if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                result.cliente.habilitarDatosComplementarios = false;
                if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                    result.cliente.habilitarDatosComplementarios = true;
                }
                if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                    result.cliente.habilitarDatosComplementariosCartaPorte = true;
                }
                if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                    result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                }
                if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                    result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                    result.cliente.habilitarValidacionCoberturaEAD = true;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                    result.cliente.habilitarValidacionCoberturaRAD = true;
                }
                //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                if (result.cliente?.documentos !== null) {
                    result.cliente.documentos?.forEach(d => {
                        documentoId++;
                        d.id = documentoId;
                    });
                }
                result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                props.saveCliente(result.cliente);
                localStorage.setItem("idioma", result.idioma);
                if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                    localStorage.setItem("diasRad", result.diasRAD);
                }
                else{
                    localStorage.setItem("diasRad", "0");
                }

                if (props.cliente?.clienteCredito?.esSuspendido === true && props.cliente?.clienteCredito?.tipoPagoID === enums.tipoPago.credito) {
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(50), // "EL CLIENTE TIENE SU CRÉDITO SUSPENDIDO, NO ES POSIBLE GENERAR COTIZACIÓN.",
                        type: 'warning',
                    });
                    history.push("/");
                    return;
                }
        
                const nuevaCotizacion = new Solicitud(initialSolicitud);
                nuevaCotizacion.modificar = false;
                nuevaCotizacion.tipoDocumento=1;
                props.setSolicitud(nuevaCotizacion);
                props.setSolicitudCopia(nuevaCotizacion);
                props.setRecoleccionOrigen(initialRecoleccionState);
                props.setRecoleccionDestino(initialRecoleccionState);
                props.saveMercancias([initialMercancia]);
                setUsuario({ ...props.usuario });
                history.push("/nueva-cotizacion");
                
            }
            setLoading(false);
        });
    }

    const Locales = {
        sunday: 'Do',
        monday: 'Lu',
        tuesday: 'Ma',
        wednesday: 'Mi',
        thursday: 'Ju',
        friday: 'Vi',
        saturday: 'Sá',
        ok: 'OK',
        today: 'Hoy',
        yesterday: 'Ayer',
        hours: 'Horas',
        minutes: 'Minutos',
        seconds: 'Segundos',
        december: 'Dic',
        December: 'Dic',
        Dec: 'Dic'
      };

    const handleFiltro = (propiedad: string) => ({ target }) => {
        setFiltro({ ...filtro, [propiedad]: target.value });
    }

    const handleFiltroInicio = (date: Date) => {
        var propiedad = "fechaInicio";
        setFiltro({ ...filtro, [propiedad]: date });
    };
    const handleFiltroFin = (date: Date) => {
        // if (date === undefined) setEndDate(new Date());
        // else
        var propiedad = "fechaFin";
        setFiltro({ ...filtro, [propiedad]: date });
    };

    const obtenerAreaServicio = async (areaServicioId) => {
        let result: AreaServicio = await apiSource.obtenerPorIdAsync("area-servicio", areaServicioId);

        return new AreaServicio(result);
    }

    const verCotizacion = (cotizacionID) => {
        setLoading(true);

        getFullCotizacion(cotizacionID).then(async response => {
            /* Solicitud*/
            const nuevaCotizacion = new Solicitud(initialSolicitud);

            nuevaCotizacion.SetValores(response, true, true);
            nuevaCotizacion.seccionId = enums.estatusSolicitud.cotizacion;
            nuevaCotizacion.cargaServiciosState = true;

            /* Origen*/
            const recoleccionOrigen = new Recoleccion(initialRecoleccionState);
            recoleccionOrigen.SetValores(response, true, true);
            recoleccionOrigen.codigoPostal = response.codigoPostalOrigen;
            recoleccionOrigen.aceptaCita = response.areaServicioRemitente.esRadConCita;
            recoleccionOrigen.colonia = response.coloniaOrigen;
            const fechaRAD = parseFecha(response.fechaCitaRAD);
            const fechaRADCedis =parseFecha(response.cotizacionRadEadCedis?.fechaCitaRADCedis);
            if (fechaRAD) {
                recoleccionOrigen.fechaCita = fechaRAD;
            } 
            else if (fechaRADCedis) {
                recoleccionOrigen.fechaCitaCedis = fechaRADCedis;
                recoleccionOrigen.EsCitaRadCedis = true;                
            } else {
                recoleccionOrigen.fechaCita = undefined;
            }
            
            recoleccionOrigen.serviciosAdicionales = response.areaServicioRemitente.serviciosAdicionales ?? response.serviciosAdicionales;
            recoleccionOrigen.direccion = response.coloniaOrigen.ciudad.nombre + " " + response.coloniaOrigen.estado.nombre + " " + response.coloniaOrigen.nombreColonia + " " + response.coloniaOrigen.codigoPostal;
            recoleccionOrigen.esForanea = response.areaServicioRemitente !== null ? response.areaServicioRemitente.esForanea : 0;
            recoleccionOrigen.paisId = response.paisIdOrigen;
            recoleccionOrigen.sucursal = response.sucursalRemitente;
            recoleccionOrigen.completado = true;
            recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.comercial;
            if (response.esResidencialOrigen === true) {
                recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.residencial;
            }
            if (response.ocurreOrigen === 1 || response.ocurreOrigen === true) {
                recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.ocurre;
            }
            if (response.esRadCitaFueraHorario === true) {
                recoleccionOrigen.EsFueraHorario = response.esRadCitaFueraHorario;
                recoleccionOrigen.horaFHDe = nuevaCotizacion.RadCitaHoraDe;
                recoleccionOrigen.horaFHHasta = nuevaCotizacion.RadCitaHoraHasta;
            }
            recoleccionOrigen.areaServicio = await obtenerAreaServicio(response.areaServicioRemitente.id);
            let nuevosServiciosOrigen: ServicioAdicional[] = [];
            let nuevosServiciosDestino: ServicioAdicional[] = [];
            recoleccionOrigen.areaServicio.serviciosAdicionales?.forEach(item => {
                response.serviciosAdicionales.forEach(item2 => {
                    if (item.id === item2.id) {
                        item.seleccionado = true;
                        if (item2.aplicaOrigen === true) {
                            const nuevoServicio = new ServicioAdicional(item);
                            nuevosServiciosOrigen.push(nuevoServicio);
                        }

                        if (item2.aplicaOrigen === false) {
                            const nuevoServicio = new ServicioAdicional(item);
                            nuevosServiciosDestino.push(nuevoServicio);
                        }
                    }
                })
            })
            //recoleccionOrigen.areaServicio.serviciosAdicionales=response.areaServicioRemitente?.serviciosAdicionales;
            //recoleccionOrigen.serviciosAdicionales=response.areaServicioRemitente?.serviciosAdicionales;
            nuevaCotizacion.serviciosAdicionalesOrigen = nuevosServiciosOrigen;
            completarValoresRecoleccion(recoleccionOrigen, recoleccionOrigen.areaServicio, props.cliente, true);




            /* Destino*/
            const recoleccionDestino = new Recoleccion(initialRecoleccionState);
            recoleccionDestino.SetValores(response, false, true);
            recoleccionDestino.codigoPostal = response.codigoPostalDestino;
            recoleccionDestino.aceptaCita = response.areaServicioDestinatario.esEadConCita;
            recoleccionDestino.colonia = response.coloniaDestino;
            nuevaCotizacion.tipoDeRecoleccionDestino = 1;
           
            const fechaCitaEAD = parseFecha(response.fechaCitaEAD);
            const fechaCitaEADCedis = parseFecha(response.cotizacionRadEadCedis.fechaCitaEADCedis);
            if (fechaCitaEAD) {
                recoleccionDestino.fechaCita = fechaCitaEAD;
                nuevaCotizacion.tipoDeRecoleccionDestino = 2;
            } 
            else if (fechaCitaEADCedis) {
                recoleccionDestino.fechaCitaCedis = fechaCitaEADCedis;
                recoleccionDestino.EsCitaEadCedis = true;                
                nuevaCotizacion.tipoDeRecoleccionDestino = 4;
            } else {            
                recoleccionDestino.fechaCita = undefined;
            }                          
            recoleccionDestino.direccion = response.coloniaDestino.descripcion;
            recoleccionDestino.esForanea = response.areaServicioDestinatario.esForanea;
            recoleccionDestino.paisId = response.paisIdDestino;
            recoleccionDestino.serviciosAdicionales = response.areaServicioDestinatario.serviciosAdicionales;
            recoleccionDestino.sucursal = response.sucursalDestinatario;
            recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.comercial;
            if (response.esResidencialDestino === true) {
                recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.residencial;
            }
            if (response.ocurreDestino === 1 || response.ocurreDestino === true) {
                recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.ocurre;
            }
            if (response.esEadCitaFueraHorario === true) {
                recoleccionDestino.EsFueraHorario = response.esEadCitaFueraHorario;
                recoleccionDestino.horaFHDe = nuevaCotizacion.EadCitaHoraDe;
                recoleccionDestino.horaFHHasta = nuevaCotizacion.EadCitaHoraHasta;
                nuevaCotizacion.tipoDeRecoleccionDestino = 3;
            }

            recoleccionDestino.completado = true;
            recoleccionDestino.areaServicio = await obtenerAreaServicio(response.areaServicioDestinatario.id);
            nuevaCotizacion.serviciosAdicionalesDestino = nuevosServiciosDestino;
            completarValoresRecoleccion(recoleccionDestino, recoleccionDestino.areaServicio, props.cliente, false);
            if(nuevaCotizacion.tipoServicio && nuevaCotizacion.tipoServicio.id !== 3){
                nuevaCotizacion.tipoServicio = await getTipoServicio(recoleccionOrigen, recoleccionDestino);
            }
            await saveServicioAdicionales(recoleccionOrigen, recoleccionDestino, nuevaCotizacion, true);
            props.setSolicitud(nuevaCotizacion);
            props.setSolicitudCopia(nuevaCotizacion);
            props.setRecoleccionOrigen(recoleccionOrigen);
            props.setRecoleccionDestino(recoleccionDestino);
            /* Mercancias */
            obtenerMercancias(response, props.saveMercancias, true);
            setLoading(false);
            history.push("/nueva-cotizacion");
        });
    }

    const getFullCotizacion = async (cotizacionId) => {
        const result = await apiSource.obtenerAsync<any>("/cotizacion/get-full-cotizacion/" + Number(cotizacionId));
        return result;
    }

    React.useEffect(() => {
        buscarCotizaciones().then();
    }, []);

    const formatDate = (date) => {
        const dateFormatted = new Date(date);
        var idioma = localStorage.getItem("idioma");
        if(idioma === 'en-US'){
            return dateFormatted.toLocaleString(idioma, { year: "numeric", month: "long", day: "numeric" });
        }
        else{
            return dateFormatted.toLocaleString("es", { year: "numeric", month: "long", day: "numeric" });
        }
        
    }

    const fechasValidas = (): boolean => {
        if (!filtro.fechaInicio || !filtro.fechaFin) {
            enqueueSnackbar("Las fechas son requeridas", { variant: "error" });
            return false;
        }

        const rangoCorrecto = filtro.fechaInicio <= filtro.fechaFin;
        const fechaInicioValida = new Date(filtro.fechaInicio).getFullYear() >= 2000;

        if (rangoCorrecto && fechaInicioValida) return true;

        const mensaje = !rangoCorrecto ? "Rango de fechas no válidas." : "Fecha Inicio no válida.";
        enqueueSnackbar(mensaje, { variant: "error" });

        return false;
    }

    const buscarCotizaciones = async () => {
        if (!fechasValidas()) return;

        setLoading(true);

        apiSource.obtenerAsync<any>("cotizacion/filtered/", filtro).then(data => {
            if (data !== null && data.length) {
                if (data.length === 1) {
                    var estatus = data[0]['estatusCotizacionID'];
                    if (estatus === 4) {
                        swal.fire({
                            title: traducirMessage(11), // '¡Aviso!',
                            text: traducirMessage(141), // "La cotización no cuenta con las tárifas vigentes.",
                            type: 'warning',
                        });
                    }
                }
                let cotizacionesLista: any[] = [];
                data.forEach(s => {
                    let cont = {
                        id: s.cotizacionID,
                        fecha: formatDate(s.fechaAlta),
                        mercancia: s.cotizacionMercancias,
                        ocurreOrigen: s.ocurreOrigen,
                        ocurreDestino: s.ocurreDestino,
                        sucursalRemitente: s.sucursalRemitente,
                        sucursalDestinatario: s.sucursalDestinatario,
                        subTotal: s.subTotal,
                        total: s.total,
                        moneda: s.monedaNombre,
                        direccionRemitente: getDireccion(s, 'origen'),
                        direccionDestinatario: getDireccion(s, 'destino'),
                        username: props.usuario.nombre
                    };
                    cotizacionesLista.push(cont);
                });
                setCotizaciones(cotizacionesLista);
                setPage(0);
            }
            else {
                setCotizaciones([]);
            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            setCotizaciones([]);
        });
    }

    const getDireccion = (row: any, tipo: string) => {
        let direccion = '';

        if (tipo === 'origen') {
            if (row.codigoPostalOrigen !== '' && row.codigoPostalOrigen !== null) {
                direccion += row.codigoPostalOrigen + " ";
            }

            if (row.direccionRemitente !== '' && row.direccionRemitente !== null) {
                direccion += row.direccionRemitente + " ";
            }
            if (row.coloniaOrigen !== null) {
                direccion += row.coloniaOrigen.nombreColonia + " " + (row.coloniaOrigen.pais.nombre || "") + " ";
            }
        }
        else {
            if (row.codigoPostalDestino !== '' && row.codigoPostalDestino !== null) {
                direccion += row.codigoPostalDestino + " ";
            }

            if (row.direccionDestinatario !== '' && row.direccionDestinatario !== null) {
                direccion += row.direccionDestinatario + " ";
            }
            if (row.coloniaDestino !== null) {
                direccion += row.coloniaDestino.nombreColonia + " " + (row.coloniaDestino.pais.nombre || "") + " ";
            }
        }

        return direccion;
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const actualizaLoginData = async (clienteId, usuarioId, userName) => {
        const result = await apiSource.obtenerAsync<IDatosLogin>("login/login-data", { clienteId: clienteId, usuarioId: usuarioId });
        return result;
    };

    return (<>
        <Container maxWidth="xl" className={classes.principal} >
            <Grid container spacing={3} >
                <Grid item xs={10} >
                    <Typography className={classes.sectionTitle}>
                        {/* Mis Cotizaciones */
                            traducirLabel(182)}
                    </Typography>
                </Grid>
                <Grid item xs={2} style={{ textAlign: "right" }}>
                    <Button variant="contained" color="primary" onClick={handleClick}>
                        {/* Nueva Cotización */
                            traducirButton(1)}
                    </Button>
                </Grid>

            </Grid>

        </Container>
        {!ocultarPortal && <Container maxWidth="xl" className={classes.filters} >

            <Grid container spacing={3} >
                <Grid item xs={1} className={classes.label}>
                    {/* Cotización */
                        traducirLabel(58)}
                </Grid>

                <Grid item xs={2}>
                    <TextField
                        variant="outlined"
                        className={classes.textField}
                        value={filtro.cotizacionId}
                        size="small"
                        onChange={handleFiltro("cotizacionId")}
                        InputProps={{
                            inputComponent: ReferenciaNumberField as any,
                            inputProps: { precision: 0, maxLength: 15, min: 0 },
                        }}
                    />
                </Grid>

                <Grid item xs={1} className={classes.label}>
                    {/* Fecha Inicio */
                        traducirLabel(134)}
                </Grid>

                <Grid item xs={2}>
                {localStorage.getItem("idioma") === 'en-US' &&
                    <CustomProvider locale={en_US}>
                    <DatePicker oneTap
                        format="MM-dd-yyyy" 
                        className="almex-datepicker"
                        value={filtro.fechaInicio}
                        //error={!filtro.fechaInicio}
                        onChange={handleFiltroInicio}
                        disabledDate={(current:any) => {
                            return moment(filtro.fechaFin,'MM-DD-YYYY')  < current;
                            }}
                    />
                </CustomProvider>
                }
                {localStorage.getItem("idioma") !== 'en-US' &&
                    <CustomProvider locale={es_ES}>
                            <DatePicker oneTap 
                            format="dd-MM-yyyy" 
                            className="almex-datepicker"
                            value={filtro.fechaInicio}
                            onChange={handleFiltroInicio}
                             disabledDate={(current:any) => {
                                 return moment(filtro.fechaFin,'dd-mm-yyyy')  < current;
                                 }}
                        />
                        
                    </CustomProvider>
                }
                
                </Grid>
                <Grid item xs={1} className={classes.label}>
                    {/* Fecha Fin */
                        traducirLabel(133)}
                </Grid>
                <Grid item xs={2}>
                {localStorage.getItem("idioma") === 'en-US' &&
                    <CustomProvider locale={en_US}>
                    <DatePicker oneTap
                        format="MM-dd-yyyy" 
                        className="almex-datepicker"
                        value={filtro.fechaFin}
                        onChange={handleFiltroFin}
                        disabledDate={(current:any) => {
                            return moment().add(0, 'days')  < current;
                            }}
                    />

                </CustomProvider>
                }
                {localStorage.getItem("idioma") !== 'en-US' &&
                    <CustomProvider locale={es_ES}>
                    
                    <DatePicker oneTap
                        format="dd-MM-yyyy" 
                        className="almex-datepicker"
                        value={filtro.fechaFin}
                        onChange={handleFiltroFin}
                        disabledDate={(current:any) => {
                            return moment()  < current;
                            }}
                    />
                </CustomProvider>
                
                }
                </Grid>
                <Grid item xs={1} className={classes.marginButton} >
                    <Button className={classes.icon} color="primary" variant="contained" onClick={() => buscarCotizaciones()}>
                        <Search />
                    </Button>
                </Grid>
            </Grid>

         </Container>}

         {!ocultarPortal && <Container maxWidth="xl" style={{ padding: "0" }}>
            <Grid container>
                <Grid item xs={12} className={classes.label}>
                    <Help comments={traducirMessage(133)} customStyle={{ top: "0", right: "0px" }} />
                </Grid>
            </Grid>
        </Container>}

        {!ocultarPortal && <Container maxWidth="xl" className={classes.table}>

            <TableContainer >
                <Table aria-label="a dense table">
                    <TableHead >
                        <TableRow>
                            <TableCell className={classes.tr}>
                                {/* NO. COTIZACIÓN */
                                    traducirLabel(195)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* FECHA */
                                    traducirLabel(129)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* ENVÍO */
                                    traducirLabel(122)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* MERCANCÍA */
                                    traducirLabel(178)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* TOTAL */
                                    traducirLabel(305)}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rowsPerPage > 0
                            ? cotizaciones.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : cotizaciones
                        ).map((row, i) => (
                            <TableRow key={i}>

                                <TableCell component="td" scope="row" className={classes.cellContent}
                                    style={{ color: "#00653b", fontSize: "15px", fontWeight: 700, textAlign: "center", cursor: "pointer" }}>
                                    <span onClick={() => verCotizacion(row.id)}>
                                        {row.id}
                                    </span>
                                </TableCell>
                                <TableCell component="td" scope="row" className={classes.cellContent}>
                                    {row.fecha}
                                </TableCell>
                                <TableCell component="td" scope="row">


                                    <Table >
                                        <TableBody>
                                            <TableRow>
                                                <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "13px", fontWeight: "bolder", width: "150px" }}>
                                                    {row.ocurreOrigen === 1 ? traducirLabel(256) : row.sucursalRemitente.nombre}
                                                </TableCell>
                                                <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px" }}>

                                                </TableCell>
                                                <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "13px", fontWeight: "bolder", width: "150px" }}>
                                                    {row.ocurreDestino === 1 ? traducirLabel(116) : row.sucursalDestinatario !== null ? row.sucursalDestinatario.nombre : ''}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "150px" }}>
                                                    {row.direccionRemitente}
                                                </TableCell>
                                                <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px" }}>
                                                    <ArrowRightAlt style={{ verticalAlign: "middle" }} />
                                                </TableCell>
                                                <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "150px" }}>
                                                    {row.direccionDestinatario}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableCell>
                                <TableCell component="td" scope="row" style={{ padding: 0 }}>

                                    <Table >
                                        <TableBody>

                                            {(row.mercancia).map((mercancia, m) => (



                                                <TableRow key={m} >
                                                    <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "20px", padding: 0, textAlign: "right" }}>
                                                        {mercancia.cantidad}
                                                    </TableCell>
                                                    {localStorage.getItem("idioma") === 'en-US' &&
                                                        <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "150px", padding: 0, textAlign: "center" }}>
                                                            {mercancia.embalaje?.etiquetaEmbalaje?.nombre}
                                                        </TableCell>
                                                    }
                                                    {localStorage.getItem("idioma") !== 'en-US' &&
                                                        <TableCell component="td" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "150px", padding: 0, textAlign: "center" }}>
                                                            {mercancia.embalaje?.nombre}
                                                        </TableCell>
                                                    }
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableCell>
                                <TableCell component="td" scope="row" className={classes.cellContent} style={{ fontWeight: 700, textAlign: "center" }}>
                                    {currencyFormat(row.subTotal)} {row.moneda}
                                </TableCell>
                            </TableRow>
                        ))}


                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={cotizaciones.length}
                rowsPerPage={rowsPerPage}
                page={page}
                labelRowsPerPage=''
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
       </Container>}

        {showLoading &&
            /*Procesando*/
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};
function parseFecha(fecha?: string | null): Date | null{
 if(!fecha) 
    return null;
 const fechaNueva = new Date(fecha);
 return fechaNueva.getFullYear() === 1900 ? null : fechaNueva; 
}
const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias,
    setUsuario: setUsuario,
    updateServicios: updateServicios,
    saveTiposEnvio: saveTiposEnvio,
    saveCliente: saveCliente,
};

export default connect(mapStateToProps, mapDispatchToProps)(CotizacionLista);
